// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"332ed3b8","977":"1664de23"}[chunkId] + ".chunk.js";
};